import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { rem } from '@mantine/core'

export const StyledHealthToolTitle = styled.p`
  margin-bottom: 0;
  color: ${theme.colors.gray900};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};
  letter-spacing: -0.2px;
  margin-bottom: 0;

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const StyledHealthToolIcon = styled.div`
  width: ${rem(40)};
  height: ${rem(40)};
`

export const StyledHealthTool = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${rem(16)};
  padding: ${rem(16)};
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #fff;
  border-radius: ${rem(12)};

  ${MediaQueries.tdDown} {
    & {
      padding-block: ${rem(16)};
    }
  }
`
